require("./bootstrap");

global.$ = global.jQuery = require("jquery");
// require('jquery-migrate');
require("jquery-ui");

window.Popper = require("popper.js");
require("bootstrap");
window.bootbox = require("bootbox");

require("sizzle");
require("admin-lte");
window.toastr = require("toastr");
window.moment = require("moment");
// window.datetimepicker = require('tempusdominus-bootstrap-4');

require("@claviska/jquery-minicolors");
require("@openreplay/tracker");
require("bootstrap-autocomplete");
// window.fileinput = require('bootstrap-fileinput');
// require('bootstrap-fileinput');
require("bootstrap4-toggle");
require("bootstrap-validate");
require("bootstrap-validator");
// require("bootstrap4-duallistbox");
require('./core/plugins/jquery.bootstrap-duallistbox.min.js');
require("inputmask");
require("jquery.cookie");
require("jquery-confirm");
require("jquery.filer");
require("jquery-file-download");
require("jquery-jeditable");
require("jquery.nicescroll");
require("jquery-placeholder");
require("jquery-serializejson");
require("jquery-slimscroll");
require("jquery-validation");
require("list.js");
require("pdfobject");
require("peity");
require("screenfull");
require("select2");
// require('tempusdominus-bootstrap-4');
require("underscore");
require("sigma");
require("graphology");
require("graphology-utils");
window.ForceSupervisor = require("graphology-layout-force/worker");

// Window.Handlebars = require('handlebars');
// require('tinymce/jquery.tinymce');
// require('tinymce');

window.Diff = require("text-diff");
window.ClipboardJS = require("clipboard");
// import EasySpeech from 'easy-speech';
// window.EasySpeech = require('easy-speech');

// require('tempusdominus-bootstrap-4');
// require('daterangepicker');

/*
require('./datatables');
*/

global.download = require("downloadjs");
global.htmlToImage = require("html-to-image");
global.LoadingOverlay = require("gasparesganga-jquery-loading-overlay");
// require('jquery-loading-overlay');

// require('./core/modal.js');
global.fg_broadcast = require("./core/socket/actions.js");
// require('./core/color.js');
